// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-download-image[data-v-50fa3ee7]{max-width:500px;width:100%}@media only screen and (min-width:1264px){.app-download-image[data-v-50fa3ee7]{max-width:800px;width:max(500px,50%)}}.left-content[data-v-50fa3ee7]{max-width:300px;text-align:center;z-index:1}@media only screen and (min-width:1264px){.left-content[data-v-50fa3ee7]{margin-left:min(100px,10%);margin-right:max(-100px,-10%);text-align:left;text-align:initial}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
